import { render, staticRenderFns } from "./manage-article.vue?vue&type=template&id=2faff412&scoped=true&"
import script from "./manage-article.vue?vue&type=script&lang=js&"
export * from "./manage-article.vue?vue&type=script&lang=js&"
import style0 from "./manage-article.vue?vue&type=style&index=0&id=2faff412&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faff412",
  null
  
)

export default component.exports